import React from 'react';
import classNames from 'classnames';
import './Button.css';

const Button = ({
    children,
    variant = 'primary',
    size = 'md',
    disabled = false,
    onClick,
    type = 'button',
    className,
    icon,
    fullWidth = false,
    ...props
}) => {
    const buttonClasses = classNames(
        'btn',
        `btn-${variant}`,
        `btn-${size}`,
        {
            'btn-disabled': disabled,
            'btn-full-width': fullWidth,
            'btn-with-icon': icon,
        },
        className
    );

    return (
        <button
            type={type}
            className={buttonClasses}
            onClick={onClick}
            disabled={disabled}
            {...props}
        >
            {icon && <span className="btn-icon">{icon}</span>}
            {children}
        </button>
    );
};

export default Button;
